import { useLocation, useNavigate, Link } from 'react-router-dom';
import Layout from '../components/shared/Layout';
import { useAuth } from '../context/AuthContext';

export default function ReportDonePage() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const { agent } = useAuth();

  if (!state?.pdf_url) { navigate('/dashboard'); return null; }

  return (
    <Layout>
      <div style={{maxWidth: 560, margin: '60px auto', textAlign:'center'}}>
        <div style={{fontSize: 64, marginBottom: 16}}>✅</div>
        <h1 style={{fontSize: 26, fontWeight: 800, marginBottom: 8}}>Report Generated!</h1>
        <p style={{color:'var(--gray-400)', marginBottom: 8, fontSize: 15}}>
          PAR Report for <strong style={{color:'var(--gray-800)'}}>{state.address}</strong>
        </p>

        {state.score && (
          <div style={{
            display:'inline-flex', flexDirection:'column', alignItems:'center',
            border: `3px solid ${state.scoreColor}`, borderRadius: 12,
            padding: '16px 32px', margin: '16px 0 28px'
          }}>
            <span style={{fontSize: 48, fontWeight: 800, color: state.scoreColor, lineHeight:1}}>{state.score}</span>
            <span style={{fontSize: 14, fontWeight: 700, color: state.scoreColor, marginTop: 6}}>{state.scoreLabel}</span>
          </div>
        )}

        <div style={{display:'flex', flexDirection:'column', gap:12, maxWidth:320, margin:'0 auto'}}>
          <a href={state.pdf_url} target="_blank" rel="noreferrer" className="btn btn-primary btn-lg">
            📄 Download PDF Report
          </a>
          <Link to="/reports/new" className="btn btn-outline btn-lg">Generate Another Report</Link>
          <Link to="/dashboard" className="btn btn-ghost btn-lg">Back to Dashboard</Link>
        </div>

        <p style={{marginTop: 28, fontSize: 13, color: 'var(--gray-400)'}}>
          Credits remaining: <strong style={{color:'var(--navy)'}}>{agent?.credits ?? 0}</strong>
          {agent?.credits === 0 && <> — <Link to="/credits">Buy more</Link></>}
        </p>
      </div>
    </Layout>
  );
}
